export function getClientNavigationUrl(fullUrl?: string): string | undefined {
  if (!fullUrl) {
    return fullUrl;
  }

  try {
    const { pathname, search, hash } = new URL(fullUrl, window.location.origin);

    return `${pathname}${search}${hash}`;
  } catch {
    return fullUrl.startsWith('/') ? fullUrl : undefined;
  }
}
